import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import React, { useEffect } from 'react';
import Reports from '../reports';
import TimeUsageReportPage from '../TimeUsageReportPage';
import EventBus from '../../common/EventBus';
import { locale } from '../../common/localization/localizationService';
import { IAuthState } from '../../redux/modules/auth';

interface IReportMainPageProps {
  selectedTab: number;
  authentication: IAuthState;
  setSelectedTab: (selectedTab: number) => void;
}

export default function ReportsMainPage(
  props: IReportMainPageProps,
): JSX.Element {
  const { selectedTab, setSelectedTab } = props;

  useEffect(() => {
    if (props.selectedTab === 1) {
      EventBus.emit('fullScreenChange', true);
    } else {
      EventBus.emit('fullScreenChange', false);
    }

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, []);

  useEffect(() => {
    if (props.selectedTab === 1) {
      EventBus.emit('fullScreenChange', true);
    } else {
      EventBus.emit('fullScreenChange', false);
    }

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, [props.selectedTab]);

  return (
    <>
      {!props.authentication.isExternalContractor && (
        <TabStrip
          selected={selectedTab}
          onSelect={(e) => setSelectedTab(e.selected)}
        >
          <TabStripTab title={locale.general._reports}>
            {selectedTab === 0 && <Reports />}
          </TabStripTab>
          <TabStripTab title={locale.timeUsageReport._header}>
            {selectedTab === 1 && <TimeUsageReportPage />}
          </TabStripTab>
        </TabStrip>
      )}
    </>
  );
}
